/**
 * Coordinates stacked fixed top banners (emulation + account switcher + announcement + onboarding + epcs).
 * Each banner owns a height CSS var; --emulation-banner-offset is their sum
 * (used by the fixed site header and any banner that needs to sit below all others).
 */
const EMU_VAR = "--site-top-banner-emu-height";
const ACCOUNT_VAR = "--site-top-banner-account-height";
const ANNOUNCEMENT_VAR = "--site-top-banner-announcement-height";
const ONBOARDING_VAR = "--site-top-banner-onboarding-height";
const EPCS_VAR = "--site-top-banner-epcs-height";
/** Sum of emu + account — where the announcement banner should sit. */
const BELOW_ACCOUNT_VAR = "--site-top-banner-below-account";
/** Sum of emu + account + onboarding — where the epcs banner should sit, before the announcement height is added. */
const BELOW_ONBOARDING_VAR = "--site-top-banner-below-onboarding";
const TOTAL_VAR = "--emulation-banner-offset";

const SLOT_VARS = {
  emulation: EMU_VAR,
  account: ACCOUNT_VAR,
  announcement: ANNOUNCEMENT_VAR,
  onboarding: ONBOARDING_VAR,
  epcs: EPCS_VAR,
} as const;

function readPx(root: HTMLElement, name: string): number {
  const raw = getComputedStyle(root).getPropertyValue(name).trim();
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}

function recomputeTotal(root: HTMLElement) {
  const emuH = readPx(root, EMU_VAR);
  const accH = readPx(root, ACCOUNT_VAR);
  const annH = readPx(root, ANNOUNCEMENT_VAR);
  const onbH = readPx(root, ONBOARDING_VAR);
  const epcsH = readPx(root, EPCS_VAR);
  root.style.setProperty(BELOW_ACCOUNT_VAR, `${emuH + accH}px`);
  root.style.setProperty(BELOW_ONBOARDING_VAR, `${emuH + accH + onbH}px`);
  root.style.setProperty(TOTAL_VAR, `${emuH + accH + annH + onbH + epcsH}px`);
}

export function setSiteTopBannerHeight(slot: keyof typeof SLOT_VARS, heightPx: number) {
  const root = document.documentElement;
  root.style.setProperty(SLOT_VARS[slot], `${Math.max(0, heightPx)}px`);
  recomputeTotal(root);
}

export function clearSiteTopBannerHeight(slot: keyof typeof SLOT_VARS) {
  setSiteTopBannerHeight(slot, 0);
}
